// removed by extract-text-webpack-plugin
module.exports = {"EightRooms":"src-components-EightRooms----EightRooms-module---EightRooms---23h5l","EightRoomsInner":"src-components-EightRooms----EightRooms-module---EightRoomsInner---1KHJL","content":"src-components-EightRooms----EightRooms-module---content---2UL1f","introText":"src-components-EightRooms----EightRooms-module---introText---n26EX","readMore":"src-components-EightRooms----EightRooms-module---readMore---1dwFV","intro":"src-components-EightRooms----EightRooms-module---intro---3auBZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EightRooms/EightRooms.module.css
// module id = 128
// module chunks = 86121489336791 258137473035900